'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTypekit = require('react-typekit');

var _reactTypekit2 = _interopRequireDefault(_reactTypekit);

var _2 = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Type generators


// ------------------------------------------------------------------------------
// -------------------------------------------------------------- Local Functions
// ------------------------------------------------------------------------------
/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
var getRandomArbitrary = function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
};
var random = Math.round(getRandomArbitrary(1, 100));

/** classnamesUndefined */
var classnamesUndefined = function classnamesUndefined() {
  return _classnames2.default.apply(undefined, arguments) || undefined;
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Container
var openTypeFeatures = (0, _glamor.css)({
  fontKerning: 'normal',
  fontVariantLigatures: 'common-ligatures contextual',
  fontFeatureSettings: '"kern", "liga", "clig", "calt"'
});
var openTypeFeaturesClass = openTypeFeatures.toString();

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------- Components
// ------------------------------------------------------------------------------
/* eslint-disable prefer-template */
/**
  * Type
  */

var Type = function (_React$Component) {
  _inherits(Type, _React$Component);

  // eslint-disable-line react/prefer-stateless-function
  /**
    * constructor - Just a standard constructor.
    */
  function Type(props) {
    _classCallCheck(this, Type);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      kitClass: undefined
    };

    _this.generateKit = _this.generateKit.bind(_this);
    return _this;
  }

  /**
    * componentDidMount
    */


  Type.prototype.componentDidMount = function componentDidMount() {
    this.generateKit();
  };

  /**
    * generateKit
    */


  Type.prototype.generateKit = function generateKit() {
    this.setState({ kitClass: (0, _2.generateParagraphType)(this.props.kit, this.props.options) + ' ' + (0, _2.generateHeadingType)(this.props.kit, this.props.options) });
  };

  /**
    * render
    */


  Type.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      _extends({
        id: 'w-' + random,
        className: classnamesUndefined(openTypeFeaturesClass, this.state.kitClass && this.state.kitClass, this.props.className && this.props.className),
        style: _extends({}, this.props.style)
      }, _lodash2.default.omit(this.props, ['className', 'style', 'kit'])),
      this.props.children,
      _react2.default.createElement(_reactTypekit2.default, { kitId: this.props.kit })
    );
  };

  return Type;
}(_react2.default.Component);
/* eslint-enable prefer-template */

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Typings
// ------------------------------------------------------------------------------


Type.propTypes = process.env.NODE_ENV !== "production" ? {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Specific props
  kit: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Generic props
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};

Type.defaultProps = {
  className: undefined,
  style: {},
  options: {}
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = Type;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/typography/lib/Type.js
// module id = 465
// module chunks = 168707334958949